import { errorToast } from "@/v2-ui/toast"
import Selector from "@/v2-backoffice-client/components/selector"
import type { SelectorItemProps } from "@/v2-backoffice-client/components/selector"
import { useLayerCategoryLayerAddManyMutation } from "@/v2-backoffice-client/layer/category/layer/add/many/layer.category.layer.add.many.mutation"
import type { LayerCategoryFragment } from "@/v2-backoffice-client/layer/category/__types__/layer.category.fragment"

export type LayerCategoryLayerAddManySelectorItemProps = Omit<
  SelectorItemProps,
  "value" | "children" | "onSelect"
> & {
  category: LayerCategoryFragment
  layerFeatureCodes: string[]
  added?: boolean
  onSelect?(): void
}

function LayerCategoryLayerAddManySelectorItem(
  props: LayerCategoryLayerAddManySelectorItemProps,
) {
  const { category, layerFeatureCodes, added, onSelect, ...selectorItemProps } =
    props

  const [addMany, { loading, error }] = useLayerCategoryLayerAddManyMutation()
  errorToast(error, {
    title: "Failed to add layers to category",
  })

  return (
    <Selector.Item
      isLoading={loading}
      value={`${category.Name ?? category.FeatureCode} ${category.FeatureCode}`}
      disabled={loading || added}
      onSelect={() => {
        addMany({
          variables: {
            layerFeatureCodes,
            categoryFeatureCode: category.FeatureCode,
          },
        })
        onSelect?.()
      }}
      {...selectorItemProps}
    >
      <Selector.ItemText
        primary={category.Name ?? category.FeatureCode}
        secondary={`${category.FeatureCode} - ${category.LayerCount} layers`}
      />
    </Selector.Item>
  )
}

export default LayerCategoryLayerAddManySelectorItem
